// Local-timezone day helpers. "Day" means the user's local calendar day,
// not a UTC day — a meal logged at 00:30 local belongs to that local date.

// Today's date as YYYY-MM-DD in the browser's local timezone.
export function todayIso(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
    d.getDate(),
  ).padStart(2, "0")}`;
}

// Minutes the browser timezone is behind UTC (JS getTimezoneOffset:
// negative for zones ahead of UTC, e.g. -120 for UTC+2). Sent to the API
// so the server can bucket meals by the user's local day.
export function browserTzOffset(): number {
  return new Date().getTimezoneOffset();
}
